module.exports = __webpack_public_path__ + "media/images/com_img01-497961dde9bfa39319832230abbb3279.png";